type VersionMessageEvent = {
  data?: {
    version?: unknown;
  };
};

type ServiceWorkerMessageTarget = Pick<ServiceWorker, 'postMessage'>;

const postVersionRequest = (
  target: ServiceWorkerMessageTarget | undefined,
  onVersion: (version: string) => void,
) => {
  if (!target) {
    return;
  }

  const messageChannel = new MessageChannel();
  const handleMessage = (event: VersionMessageEvent) => {
    const version = event.data?.version;
    if (typeof version === 'string' && version.length > 0) {
      onVersion(version);
    }

    messageChannel.port1.close?.();
  };

  if (typeof messageChannel.port1.addEventListener === 'function') {
    messageChannel.port1.addEventListener('message', handleMessage);
    messageChannel.port1.start();
  } else {
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    messageChannel.port1.onmessage = handleMessage;
  }

  target.postMessage({topic: 'version'}, [messageChannel.port2]);
};

export const requestServiceWorkerVersion = (onVersion: (version: string) => void): void => {
  const serviceWorker = navigator?.serviceWorker;
  if (!serviceWorker) {
    return;
  }

  if (serviceWorker.controller) {
    postVersionRequest(serviceWorker.controller, onVersion);
    return;
  }

  const requestVersionFromReady = async () => {
    try {
      const registration = await serviceWorker.ready;
      postVersionRequest(registration.active ?? registration.waiting ?? registration.installing ?? undefined, onVersion);
    } catch {
      // Ignore readiness failures when no active service worker is available.
    }
  };

  void requestVersionFromReady();
};
